import axios from 'axios';
import Swal from 'sweetalert2';

export const trainerTools = {
    async createGame(_trainerData, players) {
        console.log(_trainerData);
        const url = 'trener/create';
        const data = {
            sessionId: _trainerData.sessionId,
            playersCount: String(players),
            email: _trainerData.email,
        };
        const res = await this.callServer(url, data);
        if (res.status === 200) {
            return true;
        } else {
            return false;
        }
    },
    async refreshGames(_trainerData) {
        const url = 'trener/refresh';
        const data = {
            email: _trainerData.email,
        };
        const res = await this.callServer(url, data);

        _trainerData.startedGames = res.data.data.startedGames;
        // console.log(trainerData.startedGames);
        localStorage.setItem('trainerDataCache', JSON.stringify(_trainerData));
        console.log(_trainerData.startedGames);
        return _trainerData.startedGames;
    },
    async getCredits(_trainerData) {
        const url = 'trener/credits';
        const data = {
            sessionId: _trainerData.sessionId,
        };
        const res = await this.callServer(url, data);
        _trainerData.playsLeft = res.data.data.credits;
        //console.log(trainerData.startedGames);
        localStorage.setItem('trainerDataCache', JSON.stringify(_trainerData));
        return _trainerData.playsLeft;
    },
    async deleteGameFromServer(event, _trainerData) {
        const url = 'trener/delete';
        const data = {
            sessionId: _trainerData.sessionId,
            playId: event.detail.gameId,
            gameCode: event.detail.gameCode,
        };
        const res = await this.callServer(url, data);
    },
    async addOrDeletePlayer(event, _trainerData) {
        const url = 'trener/changeplayer';
        const data = {
            sessionId: _trainerData.sessionId,
            playId: event.detail.gameId,
            gameCode: event.detail.gameCode,
            changeType: event.detail.change,
        };
        console.log('add', data);
        const res = await this.callServer(url, data);
    },

    async activateGame(gameCode) {
        const url = 'trener/activate';
        const data = {
            gameCode,
        };
        const res = await this.callServer(url, data);

        if (res.status === 200) {
            return res;
        } else {
            return false;
        }
    },

    async callServer(url, data) {
        try {
            const res = await axios({
                method: 'POST',
                url,
                data,
            });
            if (res.status === 200) {
                return res;
            } else {
                Swal.fire(res.data.message);
            }
        } catch (err) {
            Swal.fire(err.response.data.message);
        }
    },
};
